module.exports = __webpack_public_path__ + "media/application/images/logo_standard-7d6b94773c25a23b3704667a47bb4935.jpg";